
















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
// import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import DateUtils from '@/common/js/DateUtils'
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import CreateBaseSetting from './create-basesetting.vue'
import EditBaseSetting from './edit-basesetting.vue'
import ResetUser from './reset-basesetting.vue'

class BaseSettingRequest extends PageRequest {
    BeginCreateTime: Date;
    EndCreateTime: Date;
    TenancyName: string;
    AuthorizeCategory?: number;
    BeginAuthorizeTime: Date;
    EndAuthorizeTime: Date;
    constructor() {
        super();
        this.AuthorizeCategory = null;
    }
}
@Component({
    name:"basesetting",
    components: { CreateBaseSetting, EditBaseSetting, ResetUser}
})
export default class ShopeeBaseSettings extends AbpBase {
    pagerequest: BaseSettingRequest = new BaseSettingRequest();
    creationTime: Date[] = [];
    AuthorizeTime: Date[] = [];
    resetModalShow: boolean = false;
    AuthorizeCategoryTypeList = [{ id: null, title: "全部" }, { id: 0, title: "个人" }, { id: 1, title: "企业" }, { id: 2, title: "永久" },{ id: 3, title: "体验用户" }];


    createModalShow: boolean = false;
    editModalShow: boolean = false;

    edit() {
        this.editModalShow = true;
    }
    create(){
        this.createModalShow=true;
    }
    get list() {
        return this.$store.state.shopeebasesetting.list;
    };
    get loading() {
        return this.$store.state.shopeebasesetting.loading;
    }
    pageChange(page: number) {
        this.$store.commit('shopeebasesetting/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('shopeebasesetting/setPageSize', pagesize);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        //filters

        if (this.creationTime.length > 0) {
            this.pagerequest.BeginCreateTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.EndCreateTime = this.creationTime[1];
        }
        if (this.AuthorizeTime.length > 0) {
            this.pagerequest.BeginAuthorizeTime = this.AuthorizeTime[0];
        }
        if (this.AuthorizeTime.length > 1) {
            this.pagerequest.EndAuthorizeTime = this.AuthorizeTime[1];
        }

        await this.$store.dispatch({
            type: 'shopeebasesetting/getAll',
            data: this.pagerequest
        })
    }
    reset() {
        this.resetModalShow = true;
    }
    async freeze(data: any, freeze: boolean) {
        await this.$store.dispatch({
            type: 'shopeebasesetting/ProcessFreeze',
            data: { id: data.id, isFreeze: freeze }
        })
        this.getpage();
    }
    get pageSize() {
        return this.$store.state.shopeebasesetting.pageSize;
    }
    get totalCount() {
        return this.$store.state.shopeebasesetting.totalCount;
    }
    get currentPage() {
        return this.$store.state.shopeebasesetting.currentPage;
    }
    columns = [
        {
            title: this.L('租户名称'),
            key: 'tenancyName',
        },
        {
            title: this.L('租户类别'),
            key: 'authorizeCategory',
            render: (h: any, params: any) => {
                let _this = this;
                return h('span', _this.AuthorizeCategoryTypeList.filter(function(item){return item.id==params.row.authorizeCategory})[0].title);
            }
        },
        {
            title: this.L('店铺上限'),
            key: 'shopNumberLimit'
        },
        {
            title: this.L('子账号数量'),
            key: 'subAccountsCount'
        },
        {
            title: this.L('创建时间'),
            key: 'crawlTime',
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)))
            }
        },
        {
            title: this.L('到期时间'),
            key: 'authorizeTime',
            render: (h: any, params: any) => {

                return h('span', (params.row.authorizeTime?DateUtils.formatLongDate(new Date(params.row.authorizeTime)):""))
            }
        }, 
        {
            title: this.L('渠道名称'),
            key: 'channelName',
        },
        {
            title: this.L('金额'),
            key: 'amount',
        },
        {
            title: this.L('备注'),
            key: 'remark',
        },
        {
            title: this.L('是否冻结'),
            key: 'isFreeze',
            render: (h: any, params: any) => {
                return h('span', (params.row.isFreeze ? "是" : "否"))
            }
        },
        {
        title:this.L('Actions'),
        key:'Actions',
        width:200,
            render: (h: any, params: any) => {
                var data = params.row;
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:()=>{
                            this.$store.commit('shopeebasesetting/edit',params.row);
                            this.edit();
                        }
                    }
                },this.L('Edit')),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px'
                    },
                    on: {
                        click: () => {
                            this.$store.state.user.id = data.tenantId;
                            this.reset();
                        }
                    }
                }, this.L('重置密码')),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px',
                        display: !data.isFreeze ? "inline-block" : "none",
                    },
                    on: {
                        click: () => {
                            this.freeze(data, true);
                        }
                    }
                }, this.L('冻结')),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px',
                        display: data.isFreeze ? "inline-block" : "none",
                    },
                    on: {
                        click: () => {
                            this.freeze(data, false);
                        }
                    }
                }, this.L('恢复'))
            ])
        }
    }
    ]
    async created() {
        await this.getpage();
    }
}
